import { render, staticRenderFns } from "./HeaderElem.vue?vue&type=template&id=32b15f30"
import script from "./HeaderElem.vue?vue&type=script&lang=js"
export * from "./HeaderElem.vue?vue&type=script&lang=js"
import style0 from "./HeaderElem.vue?vue&type=style&index=0&id=32b15f30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports